import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";

var emptyIter = /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})();

export default function emptyL() {
  return emptyIter;
}